const checkTicketExpired = ticket => (
  ticket.items
  && Array.isArray(ticket.items)
  && ticket.items.every(item => item.end_date && new Date(item.end_date) < new Date()));

export default checkTicketExpired;
